import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBranches } from '../store/slices/branchesSlice';

export const useBranches = () => {
  const dispatch = useDispatch();
  const [branches, setBranches] = useState([]);
  const { loading } = useSelector((state) => state.branches);

  const fetchBranches = () => {
    dispatch(getBranches()).unwrap()
      .then((data) => {
        setBranches(data?.items || data || []);
      })
      .catch(() => {
        setBranches([]);
      });
  };

  useEffect(() => {
    fetchBranches();
  }, [dispatch]);

  return {
    branches,
    loading,
    refetchBranches: fetchBranches // Güncelleme gerektiğinde kullanmak için
  };
}; 